import { useEffect, useState } from "react"
import { getRoundLogs } from "../tools/RoundTools";
import { RoundLogs } from "../components/RoundLogs";

export const AllTrades = () => {
    const [roundLogs, setRoundLogs] = useState([])
    useEffect(() => {
        getRoundLogs().then(data => {
            if (!data.error) {
                setRoundLogs(data.logs);
            }
        })
    }, [])
    return <div><RoundLogs logs={roundLogs} size={"sm"}/></div>
}